import { render, staticRenderFns } from "./SimplePopup.vue?vue&type=template&id=3e10cc45"
import script from "./SimplePopup.vue?vue&type=script&lang=js"
export * from "./SimplePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports